import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { API_STATUS } from 'store/constants';
import { fetchSessionDetails } from './sessionRegistrationAPI';

const initialState = {
	eventLoaded: false,
	status: '',
	eventDetails: null
};

// thunk & service
export const getSessionDetailsAsync = createAsyncThunk('sessionRegistration/fetchSessionDetails', async eventId => {
	const sessionData = await fetchSessionDetails(eventId);
	return { id: eventId, ...sessionData };
});

export const sessionRegistrationSlice = createSlice({
	name: 'eventRegistration',
	initialState,
	reducers: {
		setEventDetails: (state, action) => {
			// TODO
		}
	},

	extraReducers: builder => {
		builder
			.addCase(getSessionDetailsAsync.pending, state => {
				state.status = API_STATUS.PENDING;
			})
			.addCase(getSessionDetailsAsync.rejected, state => {
				state.status = API_STATUS.REJECTED;
			})
			.addCase(getSessionDetailsAsync.fulfilled, (state, action) => {
				state.eventDetails = action.payload;
				state.eventLoaded = true;
				state.status = API_STATUS.COMPLETED;
			});
	}
});

export const selectSessionLoaded = state => state.eventRegistration.status !== API_STATUS.PENDING;
export const selectSessionDetails = eventId => state => {
	if (eventId === state.eventRegistration.eventDetails?.id) return state.eventRegistration.eventDetails;
};

export const { setEventDetails } = sessionRegistrationSlice.actions;

export default sessionRegistrationSlice.reducer;
